<template>
  <el-drawer
    class="rounded-tl rounded-bl !w-[426px] onc-drawer"
    :model-value="open"
    :title="title"
    :direction="direction"
    :show-close="false"
    :before-close="handleClose"
    @click="(e) => $bus.$emit('CustomDrawer:click', [e, false])"
  >
    <template #header="{ close, titleId }">
      <span :id="titleId" class="drawer-title">
        {{ title }}
      </span>
      <font-awesome-icon
        v-if="showClose"
        class="close-btn"
        :icon="['fas', 'xmark']"
        @click="close"
      />
    </template>
    <slot />
  </el-drawer>
</template>

<script setup lang="ts">
import { useNuxtApp } from "nuxt/app";
import Emitter from "~/types/Emitter";

const { $bus }: Emitter = useNuxtApp();
const emit = defineEmits(["close"]);

defineProps({
  open: {
    type: Boolean,
    required: true,
  },
  title: {
    type: String,
    default: "",
  },
  direction: {
    type: String,
    default: "rtl",
  },
  showClose: {
    type: Boolean,
    default: true,
  },
});

const handleClose = () => {
  emit("close");
  $bus.$emit("CustomDrawer:click", [{}, true]);
};
</script>

<style scoped>
.close-btn {
  @apply cursor-pointer text-black text-base w-[24px] h-[24px];
}
.drawer-title {
  @apply text-black text-base font-semibold font-['Inter'] font-[16px];
}
</style>

<style>
.onc-drawer .el-drawer__body::-webkit-scrollbar {
  display: none; /* hide scrollbar */
}

.onc-drawer .el-drawer__header {
  @apply border-b border-accent-300 mb-0 px-5 pt-[19px] pb-[18px];
}

.onc-drawer .el-drawer__body {
  @apply p-0;
}
</style>
